var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecklistLady(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 207.941,
    viewBox: "0 0 210 207.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5315",
    "data-name": "Rectangle 5315",
    width: 11.258,
    height: 47.969,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5317",
    "data-name": "Rectangle 5317",
    width: 35.14,
    height: 5.19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5321",
    "data-name": "Rectangle 5321",
    width: 35.14,
    height: 5.191,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(-380.5 -110)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M97.794,195.588C44.033,195.588,0,151.953,0,98.051S44.033,0,97.794,0s97.794,44.148,97.794,98.051S151.555,195.588,97.794,195.588Z",
    transform: "translate(387.706 110)",
    fill: "#bce8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8676",
    "data-name": "Group 8676",
    transform: "translate(380.5 137.794)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1483",
    "data-name": "Ellipse 1483",
    cx: 35,
    cy: 4.118,
    rx: 35,
    ry: 4.118,
    transform: "translate(0 166.764)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9995",
    "data-name": "Group 9995",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9996",
    "data-name": "Group 9996",
    transform: "translate(0 45.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M261.969,197.963a.807.807,0,0,0-.807.805l-.2,86.387a.807.807,0,0,0,.8.809l69.423.16a.807.807,0,0,0,.807-.806l.2-86.387a.807.807,0,0,0-.8-.809Z",
    transform: "translate(-260.963 -194.917)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M277.265,213.264a.807.807,0,0,0-.807.805l-.186,81.22a.807.807,0,0,0,.8.809l64.269.148a.807.807,0,0,0,.807-.805l.186-81.22a.807.807,0,0,0-.8-.809Z",
    transform: "translate(-273.688 -207.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M373.185,409.234l-47.355-.109a1.211,1.211,0,0,1,.006-2.422l47.355.109a1.211,1.211,0,0,1-.006,2.422Z",
    transform: "translate(-313.876 -368.329)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M456.37,276.085l-31.417-.072c-.443,0-.8-.544-.8-1.213s.362-1.21.8-1.209l31.417.072c.443,0,.8.544.8,1.213S456.813,276.086,456.37,276.085Z",
    transform: "translate(-396.604 -257.745)",
    fill: "#6c63fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M456.276,317.111l-31.417-.072c-.443,0-.8-.544-.8-1.213s.362-1.21.8-1.209l31.417.072c.443,0,.8.544.8,1.213S456.718,317.112,456.276,317.111Z",
    transform: "translate(-396.525 -291.828)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M373.075,455.507l-47.355-.109a1.211,1.211,0,0,1,.006-2.422l47.355.109a1.211,1.211,0,0,1,.022,2.422Z",
    transform: "translate(-313.785 -406.771)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M372.975,501.779l-47.355-.109a1.211,1.211,0,0,1,.006-2.422l47.355.109a1.211,1.211,0,0,1,.023,2.422Z",
    transform: "translate(-313.702 -445.212)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M372.866,548.053l-47.355-.109a1.211,1.211,0,0,1,.006-2.422l47.355.109a1.211,1.211,0,0,1,.023,2.422Z",
    transform: "translate(-313.611 -483.655)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M349.461,592.326l-24.058-.109a1.211,1.211,0,0,1,.006-2.422l24.058.109a1.211,1.211,0,0,1,.023,2.422Z",
    transform: "translate(-313.522 -520.435)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M349.355,638.6l-24.058-.109a1.211,1.211,0,0,1,.006-2.422l24.058.109a1.211,1.211,0,0,1,.023,2.422Z",
    transform: "translate(-313.434 -558.877)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M420.361,421.217",
    transform: "translate(-393.45 -380.388)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M521.446,189.061V183.3a3.252,3.252,0,1,0-6.5-.143h.716a2.543,2.543,0,0,1,2.534-2.447h.037a2.545,2.545,0,0,1,2.5,2.585v5.814a1.706,1.706,0,0,1-1.7,1.685h-.021a1.707,1.707,0,0,1-1.68-1.731l0-5.724a.857.857,0,1,1,1.714-.006V185a.358.358,0,1,0,.716,0v-1.669a1.572,1.572,0,1,0-3.145.005l0,5.725A2.423,2.423,0,0,0,519,191.509h.03a2.423,2.423,0,0,0,2.416-2.395C521.446,189.1,521.446,189.077,521.446,189.061Z",
    transform: "translate(-472.065 -179.967)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7462",
    "data-name": "Path 7462",
    d: "M532.829,581.545a7.985,7.985,0,0,1-.5,2.795,7.757,7.757,0,0,1-.554,1.184,7.978,7.978,0,0,1-13.861,0q-.106-.185-.2-.375a7.992,7.992,0,1,1,15.117-3.6Z",
    transform: "translate(-473.656 -506.93)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1484",
    "data-name": "Ellipse 1484",
    cx: 1.527,
    cy: 1.53,
    rx: 1.527,
    ry: 1.53,
    transform: "translate(50.076 72.905)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M521.922,614.821c.673-.729,1.572-1.886,2.415-1.05.423.394,1.086,1.371,1.72.733l4.951-4.964a.982.982,0,0,1,1.406.025l4.124,4.446a7.759,7.759,0,0,1-.554,1.184H522.123Z",
    transform: "translate(-477.865 -536.603)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7464",
    "data-name": "Path 7464",
    d: "M320.829,260.544a7.988,7.988,0,0,1-.5,2.795,7.758,7.758,0,0,1-.554,1.184,7.978,7.978,0,0,1-13.861,0q-.106-.185-.2-.375a7.992,7.992,0,1,1,15.117-3.6Z",
    transform: "translate(-297.447 -240.257)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1485",
    "data-name": "Ellipse 1485",
    cx: 1.527,
    cy: 1.53,
    rx: 1.527,
    ry: 1.53,
    transform: "translate(14.286 18.579)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7465",
    "data-name": "Path 7465",
    d: "M309.922,293.821c.673-.729,1.572-1.886,2.415-1.05.423.394,1.086,1.371,1.72.733l4.951-4.964a.981.981,0,0,1,1.406.025l4.124,4.446a7.767,7.767,0,0,1-.554,1.184H310.123Z",
    transform: "translate(-301.656 -269.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1486",
    "data-name": "Ellipse 1486",
    cx: 0.844,
    cy: 0.846,
    rx: 0.844,
    ry: 0.846,
    transform: "translate(45.836 8.485)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9997",
    "data-name": "Group 9997",
    transform: "translate(57.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3114-2",
    "data-name": "Path 3114",
    d: "M261.969,197.963a.807.807,0,0,0-.807.805l-.2,86.387a.807.807,0,0,0,.8.809l69.423.16a.807.807,0,0,0,.807-.806l.2-86.387a.807.807,0,0,0-.8-.809Z",
    transform: "translate(-260.963 -194.917)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115-2",
    "data-name": "Path 3115",
    d: "M277.265,213.264a.807.807,0,0,0-.807.805l-.186,81.22a.807.807,0,0,0,.8.809l64.269.148a.807.807,0,0,0,.807-.805l.186-81.22a.807.807,0,0,0-.8-.809Z",
    transform: "translate(-273.688 -207.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124-2",
    "data-name": "Path 3124",
    d: "M420.361,421.217",
    transform: "translate(-393.45 -380.388)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125-2",
    "data-name": "Path 3125",
    d: "M521.446,189.061V183.3a3.252,3.252,0,1,0-6.5-.143h.716a2.543,2.543,0,0,1,2.534-2.447h.037a2.545,2.545,0,0,1,2.5,2.585v5.814a1.706,1.706,0,0,1-1.7,1.685h-.021a1.707,1.707,0,0,1-1.68-1.731l0-5.724a.857.857,0,1,1,1.714-.006V185a.358.358,0,1,0,.716,0v-1.669a1.572,1.572,0,1,0-3.145.005l0,5.725A2.423,2.423,0,0,0,519,191.509h.03a2.423,2.423,0,0,0,2.416-2.395C521.446,189.1,521.446,189.077,521.446,189.061Z",
    transform: "translate(-472.065 -179.967)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1486-2",
    "data-name": "Ellipse 1486",
    cx: 0.844,
    cy: 0.846,
    rx: 0.844,
    ry: 0.846,
    transform: "translate(45.836 8.485)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10079",
    "data-name": "Group 10079",
    transform: "translate(9.209 24.463)",
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10078",
    "data-name": "Group 10078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10077",
    "data-name": "Group 10077",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7643",
    "data-name": "Path 7643",
    d: "M109.281,321.893l-9.953.057a.527.527,0,0,0-.516.523q.029,4.989.057,9.977a.527.527,0,0,0,.521.517l9.953-.057a.477.477,0,0,0,.35-.141l.018-.016.01-.01a.48.48,0,0,0,.139-.355l-.057-9.977a.527.527,0,0,0-.521-.517m-.461,9.98-8.916.051q-.025-4.469-.051-8.938l8.916-.051q.025,4.469.051,8.938",
    transform: "translate(-98.813 -321.893)",
    fill: "#8c9498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7644",
    "data-name": "Path 7644",
    d: "M110.12,468.041l-9.953.057a.527.527,0,0,0-.515.523q.029,4.989.057,9.977a.527.527,0,0,0,.521.517l9.953-.057a.477.477,0,0,0,.35-.141l.018-.017.01-.01a.48.48,0,0,0,.139-.355l-.057-9.977a.526.526,0,0,0-.521-.517m-.461,9.98-8.916.051q-.026-4.469-.051-8.938l8.916-.051q.025,4.469.051,8.938",
    transform: "translate(-99.546 -449.593)",
    fill: "#8c9498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    d: "M110.959,614.19l-9.953.057a.527.527,0,0,0-.515.523l.057,9.977a.526.526,0,0,0,.521.517l9.953-.057a.478.478,0,0,0,.35-.141l.018-.017.01-.01a.481.481,0,0,0,.139-.355l-.057-9.977a.526.526,0,0,0-.521-.517m-.461,9.98-8.916.051q-.025-4.469-.051-8.938l8.916-.051q.025,4.469.051,8.938",
    transform: "translate(-100.28 -577.295)",
    fill: "#8c9498"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M129.7,307.428l2.283-.778,1.284,2.286,10.884-7.961,1.272.248-12.649,10.52Z",
    transform: "translate(-116.603 -279.153)",
    fill: "#6c63fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M123.974,457.32l2.283-.777,1.284,2.286,10.884-7.961,1.272.247-12.649,10.52Z",
    transform: "translate(-111.597 -410.124)",
    fill: "#6c63fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M123.121,595.656l2.283-.778,1.284,2.286,10.884-7.961,1.272.248L126.2,599.97Z",
    transform: "translate(-110.851 -530.998)",
    fill: "#6c63fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10082",
    "data-name": "Group 10082",
    transform: "translate(26.305 65.173)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10081",
    "data-name": "Group 10081",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10080",
    "data-name": "Group 10080",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5316",
    "data-name": "Rectangle 5316",
    width: 35.112,
    height: 4.988,
    transform: "translate(0 0.202) rotate(-0.329)",
    fill: "#8c9498"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10085",
    "data-name": "Group 10085",
    transform: "translate(26.193 45.634)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10084",
    "data-name": "Group 10084",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10083",
    "data-name": "Group 10083",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5318",
    "data-name": "Rectangle 5318",
    width: 35.112,
    height: 4.988,
    transform: "translate(0 0.202) rotate(-0.329)",
    fill: "#8c9498"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10088",
    "data-name": "Group 10088",
    transform: "translate(26.081 26.094)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10087",
    "data-name": "Group 10087",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10086",
    "data-name": "Group 10086",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5320",
    "data-name": "Rectangle 5320",
    width: 35.111,
    height: 4.988,
    transform: "translate(0 0.202) rotate(-0.329)",
    fill: "#8c9498"
  })))))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1620",
    "data-name": "Ellipse 1620",
    cx: 35,
    cy: 4.118,
    rx: 35,
    ry: 4.118,
    transform: "translate(58.677 171.911)",
    fill: "#6639b7",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10001",
    "data-name": "Group 10001",
    transform: "translate(479.323 145)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1619",
    "data-name": "Ellipse 1619",
    cx: 38.088,
    cy: 4.118,
    rx: 38.088,
    ry: 4.118,
    transform: "translate(35 160.588)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7485",
    "data-name": "Path 7485",
    d: "M712.448,280.175c-.687-5.057-1.548-10.487-5.1-14.138a11.91,11.91,0,0,0-17.259.179,15.91,15.91,0,0,0-3.832,10.455,41.335,41.335,0,0,0,1.671,11.228,34.334,34.334,0,0,0,14.382-2.843,23.116,23.116,0,0,1,3.448-1.359c1.2-.306,2.052.464,3.167,1l.612-1.177c.5.936,2.052.659,2.614-.241A4.658,4.658,0,0,0,712.448,280.175Z",
    transform: "translate(-652.171 -262.425)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    d: "M585.872,509.622l-3.629,2.41-10.985-12.911,5.357-3.557Z",
    transform: "translate(-481.395 -355.607)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    d: "M873.306,700.62,861.933,708.5l-.1-.151a5.72,5.72,0,0,1,1.5-7.7h0l6.946-4.811Z",
    transform: "translate(-767.276 -543.79)",
    fill: "#fff",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7488",
    "data-name": "Path 7488",
    d: "M468.758,522.682h-4.351l-2.07-16.854h6.422Z",
    transform: "translate(-411.134 -362.213)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7489",
    "data-name": "Path 7489",
    d: "M735.409,720.665H719.187v-.178c0-3.028,2.827-5.484,6.314-5.484h9.909Z",
    transform: "translate(-676.675 -555.96)",
    fill: "#fff",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7490",
    "data-name": "Path 7490",
    d: "M626.935,366.288,610.506,354.5a3.194,3.194,0,1,0-3.836,2.762c2.054,1.732,17.053,16.712,19.2,15.922,2.18-.8,11.71-2.254,11.71-2.254l.265-9.087Z",
    transform: "translate(-600.269 -321.644)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7504",
    "data-name": "Path 7504",
    d: "M690.412,390.755l2.781-.4-5.147-7.28-1.533.685Z",
    transform: "translate(-654.471 -341.27)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7491",
    "data-name": "Path 7491",
    d: "M704.733,450.07l.155,20.736s3.555,30.724,4.867,35.914,5.568,37.185,5.568,37.185,6.183,2.028,8.055,0-3.909-40.78-3.909-40.78l1.684-26.025,9.712,26.082s30.258,36.573,33.066,37.5,5.184-3.948,5.184-3.948l-28.8-44.411-6.557-25.951s.816-13.423-6.531-18.592Z",
    transform: "translate(-665.159 -383.983)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1487",
    "data-name": "Ellipse 1487",
    cx: 9.484,
    cy: 9.524,
    rx: 9.484,
    ry: 9.524,
    transform: "translate(36.125 3.707)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7506",
    "data-name": "Path 7506",
    d: "M.086.9,5.61,0s1.554,7.134.767,9.031-4.448,2.2-5.593-.187S.086.9.086.9Z",
    transform: "translate(47.343 19.98) rotate(-7)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7507",
    "data-name": "Path 7507",
    d: "M705.829,459.816v3c2.6.154,15.411-1.177,15.411-1.177l13.6-.663a13.027,13.027,0,0,0-1.227-6.174C732.077,451.292,705.829,459.816,705.829,459.816Z",
    transform: "translate(-666.255 -380.824)",
    opacity: 0.096
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    d: "M593.233,362.657",
    transform: "translate(-593.233 -329.198)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M719.482,345.2c-1.118-2.234-.433-2.461-2.815-3.185-.825-.251-5.227,8.877-5.227,8.877s-4.207-7.609-4.921-7.207c-2.439,1.373-.892.813-2.332,3.221l-4.693,7.852a24.434,24.434,0,0,0-2.744,5.64,8.247,8.247,0,0,0,.381,6.126c.887,1.654.892,5.27,1.784,6.921.927,1.717-.445,8.937-.445,8.937l.445,14.371c2.025.119,6.92-1.063,11.8-1.519,8.712-.814,18.434-1.234,18.434-1.234s-1.015-10.178-2.555-13.682-3.621-3.23-3.2-5.3A46.394,46.394,0,0,0,719.482,345.2Z",
    transform: "translate(-659.748 -315.909)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M693.731,368.9A65.084,65.084,0,0,0,701,360.88c2.115-2.928-.459-5.185,0-8.773.2-1.145,4.338-3.415,3.992-4.524a3.51,3.51,0,0,0-2.391-2.3c-1.8-.4-3.437,1.046-4.721,2.373L686.514,359.4l7.238,9.568Z",
    transform: "translate(-653.406 -317.973)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    d: "M744.719,395.416c-.8-2.189-2.244-11.759-2.244-11.759l-9.049-.266,4.424,10.957-12.072,16.971.063.1a3.209,3.209,0,1,0,2.678,3.407.22.22,0,0,0,.277-.048C730.138,413.09,745.517,397.605,744.719,395.416Z",
    transform: "translate(-676.39 -342.541)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    d: "M758.556,362.645a65.416,65.416,0,0,0-3.068-10.393,21.831,21.831,0,0,0-6.224-8.733,7.267,7.267,0,0,0-3.039-1.579,3.493,3.493,0,0,0-3.2.865c-1.27,1.341-.888,3.494-.422,5.285l4.12,15.84,11.9-1.266Z",
    transform: "translate(-689.305 -315.814)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    d: "M769.245,398.625l-.2-1.109-7.253.753a3.358,3.358,0,0,1,.4,1.2C766.158,399.044,765.348,399.065,769.245,398.625Z",
    transform: "translate(-701.964 -350.436)",
    opacity: 0.099
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7505",
    "data-name": "Path 7505",
    d: "M-1.194-4.713l5.586-.55S3.5,3.091,2.144,3.188-1.194-4.713-1.194-4.713Z",
    transform: "translate(49.725 31.94)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7497",
    "data-name": "Path 7497",
    d: "M713.232,277.063a38.232,38.232,0,0,0-1.3-6.8,11.011,11.011,0,0,0-3.43-5.43c-2.55-1.946-5.852-1.57-8.711-.451a13.074,13.074,0,0,0-5.929,4.3,10.25,10.25,0,0,0-1.855,7.9l9.15-2.557-.334.279a8.656,8.656,0,0,1,3.931,6.061,10.269,10.269,0,0,1-1.61,7.5l6.24-2.618A6.306,6.306,0,0,0,712.8,282.7C713.683,281.1,713.478,278.975,713.232,277.063Z",
    transform: "translate(-655.767 -263.091)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7498",
    "data-name": "Path 7498",
    d: "M609.574,339.012l-6.1,9.195a1.594,1.594,0,0,1-2.8-.269,1.483,1.483,0,0,1-.1-.305,1.614,1.614,0,0,1,.238-1.2l6.1-9.195a1.6,1.6,0,1,1,2.658,1.779Z",
    transform: "translate(-597.95 -312.375)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7499",
    "data-name": "Path 7499",
    d: "M601.335,364.02l-1.235,1.85-2.185,1.934a.871.871,0,0,1-1.4-.936l.956-2.811,1.2-1.815Z",
    transform: "translate(-595.32 -328.93)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7500",
    "data-name": "Path 7500",
    d: "M619.255,329.591,616.2,332.3a.876.876,0,0,0,.093,1.383l.578.387-1.673,2.521a.355.355,0,1,0,.591.4l1.673-2.521.579.387a.869.869,0,0,0,1.206-.241.885.885,0,0,0,.1-.206l1.31-3.876a.871.871,0,0,0-1.4-.937Z",
    transform: "translate(-607.363 -307.777)",
    fill: "#3f3d56"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistLady);
export default __webpack_public_path__ + "static/media/checklist_lady.3e6006987a005d22cee5349650dbb434.svg";
export { ForwardRef as ReactComponent };